/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* global Swiper */

import router from '../router';
import helpers from '../helpers';
import analytics from '../analytics';

let slider;
let repeat = 0;

const chacheArticle = () => {
	if (!$('.menu__item--article').length) {
		return;
	}

	const article = window.location.pathname;
	const link = document.querySelector('.menu__item--article');

	if (article === '/') {
		link.setAttribute('href', '/article/1');
	} else if (article === '/1') {
		link.setAttribute('href', '/article/0');
	} else {
		link.setAttribute('href', `/article${article}`);
	}
};


const isMobile = helpers.isMobile();

const actionSelect = (event) => {
	const target = event.currentTarget;
	const value = target.value;
	const option = target.querySelectorAll('option');
	// eslint-disable-next-line no-shadow
	const selectedOption = [...option].find((option) => option.selected).text;
	router.navigate(value);

	ga('send', 'event', 'main', 'slider topic change', `${selectedOption}`, {nonInteraction: false});
	ga('send', 'event', 'main', 'show topic', `${selectedOption}`, {nonInteraction: true});
	setTimeout(() => {
		const hash = window.location.pathname + window.location.hash;
		analytics.virtualHit(hash);
		init();
		chacheArticle();
	}, 0);
};

function clicEvent() {
	const select = document.querySelector('.intro__select select');
	$(`.intro__select select option[value="${window.location.pathname}"]`).prop('selected', true);
	chacheArticle();
	
	select.addEventListener('change', actionSelect);
}
function init() {
	if (isMobile) {
		slider = new Swiper('.intro__content.for-mobile .js-intro-slider', {
			slidesPerView: 'auto',
			spaceBetween: 20,
			observer: true,
			on: {
				init(swiper) {
					clicEvent(swiper);
					if (repeat === 0) {
						const option = $(swiper.el).closest('.page').find('.intro__select option');
						const name = [...option].find((option) => option.selected).text;
						ga('send', 'event', 'main', 'show topic', `${name}`, {nonInteraction: true});
						repeat = 1;
					}
				},
			},
		});
	}
}

function destroy() {
	slider.destroy();
}
export default {
	init,
	destroy,
};
